<template>
  <div class="pay-manangment">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <div>
      <div class="searchCon">
        <div class="searchMain">
          <ots-refer
            :selectList="selectList"
            :request-form="selectForm"
            @search="getResult"
          />
        </div>
      </div>
      <div class="content">
        <div class="total-price">
          <span class="total-price-label">合计已缴费：</span>
          <span class="price">￥{{ totalPrice }}</span>
        </div>
        <ots-table-group-new
          :tableHeader="tableHeader"
          :tableOption="tableOption"
          :tableData="tableData"
          :batchOperBtn="batchOperBtn"
          :pagination="pagination"
          @changeNum="changeSize"
          @changePage="changePage"
          @handleSelectionChange="bachOper"
        ></ots-table-group-new>
      </div>
      <ots-custom-dialog
        :dialog.sync="dialogVisible"
        title="导出设置"
        width="40%"
      >
        <template v-slot:content>
          <div class="export-setting">
            <div>请选择数据范围</div>
            <div class="mt10">
              <el-radio-group v-model="exportType">
                <el-radio-button label="2">选中数据</el-radio-button>
                <el-radio-button label="1">查询结果数据</el-radio-button>
                <el-radio-button label="3">全部数据</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="dialogVisible = false">取消</el-button>
          <el-button round type="primary" @click="exportData">确定</el-button>
        </template>
      </ots-custom-dialog>
      <ots-custom-dialog
        :dialog.sync="refundDialog"
        title="退费"
        width="40%"
      >
        <template v-slot:content>
          <div class="export-setting">
            <el-form inline label-width="120px" label-position="right" :model="refundForm" class="dialogForm" :rules="refundRules" ref="refundForm">
              <div>
                <el-form-item label="学生">
                  {{studentInfo.realName}}
                </el-form-item>
              </div>
              <div>
                <el-form-item label="证件号">
                  {{studentInfo.cardNo}}
                </el-form-item>
              </div>
              <div>
                <el-form-item label="退费金额">
                  {{studentInfo.money}}
                </el-form-item>
              </div>
              <div>
                <el-form-item label="退费时间" prop="refundDate" v-if="!HEMA">
                  <el-date-picker
                    :value-format="dataFormat"
                    v-model="refundForm.refundDate"
                    type="datetime"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="退费备注" prop="refundText">
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="refundForm.refundText">
                  </el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="refundDialog = false">取消</el-button>
          <el-button round type="primary" @click="refundFn">确定</el-button>
        </template>
      </ots-custom-dialog>
    </div>
  </div>
</template>

<script>
import { getSelectPlanFn, getSinglePlan } from '@/http/modules/examSet/examBatch'

const timeShortCuts = [
    {
      text: "今天",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "昨天",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "最近一周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
      },
    },
  ]
export default {
  name: "payOrders",
  data() {
    return {
      customSearch: [],
      dialogVisible: false,
      refundDialog: false,
      totalPrice: 0,
      exportType: null,
      dataFormat: 'yyyy-MM-dd HH:mm:ss',
      mainTopBtnList: [],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '教学点',
          type: 'select',
          isSearch: true,
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "订单号",
          type: "input",
          requestKey: "backId",
          placeholder: "请输入"
        },
        {
          title: "缴费状态",
          type: "select",
          requestKey: "multiple_state",
          label: "key",
          value: "value",
          multiple: true,
          data: [
            {
              key: "已缴费",
              value: "1",
            },
            {
              key: "退费",
              value: "2",
            },
            {
              key: "未缴费",
              value: "0",
            },
          ],
        },
        {
          title: "缴费日期",
          type: "daterange",
          /* 一定会返回一个数组，detailData 为数组名(日期联动返回数组) */
          requestKey:"dateRange_pay",
          pickerOptions: {
            shortcuts: timeShortCuts
          },
        },
        {
          title: "是否重复缴费",
          type: "select",
          requestKey: "doublePay",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "是",
              value: "1",
            },
            {
              key: "否",
              value: "0",
            },
          ],
        },
        {
          title: "付款方式",
          type: "select",
          requestKey: "payType",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "平台在线缴费",
              // value: "21",
              value: "1",
            },
            {
              key: "第三方自主缴费",
              // value: "-100",
              value: "2",
            },
          ],
        },
        {
          title: "退费日期",
          type: "daterange",
          /* 一定会返回一个数组，detailData 为数组名(日期联动返回数组) */
          requestKey:"dateRange_refund",
          pickerOptions: {
            shortcuts: timeShortCuts
          },
        },
        {
          title: "证件号",
          type: "input",
          requestKey: "cardNo",
          placeholder: "请输入",
        },
        {
          title: "姓名",
          type: "input",
          requestKey: "realName",
          placeholder: "请输入",
        },
      ],
      selectForm: {
        stationId:[],
        dateRange_pay: [],
        dateRange_refund: [],
        multiple_state: ['1', '2'],
        state: '',
        planId: null,
        payBeginDate: "",
        payEndDate: "",
        refundDateBegin: "",
        refundDateEnd: "",
        realName: "",
        orders: "",
        cardNo: "",
        backId:'',
        page: 1,
        size: 10,
      },
      tableHeader: [
        // {
        //   title: "考试批次",
        //   prop: "planName",
        // },
        {
          title: "姓名",
          prop: "realName",
          width: "70"
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "缴费课程",
          prop: "courseName",
        },
        {
          title: "金额",
          prop: "money",
          width: "80"
        },
        {
          title: "付款方式",
          prop: "payType",
          width: "80"
        },
        {
          title: "订单号",
          prop: "backId",
        },
        {
          title: "缴费时间",
          prop: "payDate",
        },
        {
          title: "缴费状态",
          prop: "state",
          type: 'tag_Z',
          tagColor: (scope) => {
            const options = {
              '已缴费': 'col_green',
              '未缴费': 'col_grayQ',
              '退费': 'col_orange'
            }
            return options[scope.row.state]
          },
          width: "80"
        },
        {
          title: "重复缴费",
          prop: "doublePay",
          width: "60"
        },
        {
          title: "退费时间",
          prop: "refundDate",
        },
        {
          title: "退费备注",
          prop: "refundText"
        },
        {
          title: "操作",
          type: 'button',
          width: '100',
          // formatter: (val) => (val.row.state == '已缴费' && !this.isOverPay ? "<span>退费标记</span>" : ""),
          formatter: (val) => this.dealOptionsBtn(val.row),
          disableFn: (val) => this.optionsFlag(val.row),
          click: this.dealRefund,
          align: 'right'
        },
      ],
      tableOption: {
        multiple: true,
      },
      tableData: [],
      batchOperBtn: [
        {
          title: "导出",
          icon: "iconfont icon-daochu",
          click: this.showExportDialog
        }
      ],
      pagination: {
        total: 0,
      },
      multipleSelectList: [],
      selectPlanInfo: {
        // payType: "", //缴费方式   1 线上  2 线下
        endPay: "", //缴费时间
        classPublish: "",
      },
      refundForm: {
        billId: '',
        // refundDate: '',
        refundText: '',
      },
      refundRules: {
        refundDate: [
          {required: !this.HEMA, message: '请选择退费时间', trigger: 'change'},
        ],
        refundText: [
          { max: 50, message: '最多可输入50个字', trigger: 'blur' }
        ]
      },
      studentInfo: {
        // name: '',
        // cardNo: '',
        // money: ''
      },
      currentTime: '',

      // 是否是"河马支付"
      HEMA: false,

    };
  },
  computed: {
    isOverPay () {
      return new Date().getTime(this.currentTime) > new Date(this.selectPlanInfo.endPay).getTime() 
    }
  },
  watch: {
    "selectForm.planId"(val) {
      // 更新表格数据
      // this.resetTableForm()
      this.getResult()
      // 更新选择项
      // this.getPlanCourseData(val);
      this.getPlanData(val);
      
    },
    "selectForm.dateRange_pay"(val) {
      if (val && val.length) {
        this.selectForm.payDateBegin = val[0];
        this.selectForm.payDateEnd = val[1];
      } else {
        this.selectForm.payDateBegin = "";
        this.selectForm.payDateEnd = "";
      }
    },
    "selectForm.dateRange_refund"(val) {
      if (val && val.length) {
        this.selectForm.refundDateBegin = val[0];
        this.selectForm.refundDateEnd = val[1];
      } else {
        this.selectForm.refundDateBegin = "";
        this.selectForm.refundDateEnd = "";
      }
    },
    'selectForm.multiple_state':{
      handler (val) {
        this.selectForm.state = val.join()
      },
      immediate: true
    },
    'refundDialog' (val) {
      if (!val) {
        this.$refs['refundForm'].resetFields()
      }
    },
  
  },
  mounted() {
    this.getPlan();
  },
  methods: {
    getPlan() {
      this.mixin_getServerTime().then( res => {
        if (res.code == 1) {
          this.currentTime = res.data
        }
      })  
      getSelectPlanFn({needAudit: 3}).then( ({data}) => {
          this.$set(this.selectList[0], "data", data);
          if (data.length > 0) {
            this.selectForm.planId = data[0].id;
          }
      })
      this.mixin_getSelectStation().then((data) => {
        this.$set(this.selectList[1], "data", data);
      });
    },
    getPlanData(planId) {
      getSinglePlan({ planId }).then(({ data }) => {
        for (let item in this.selectPlanInfo) {
          this.selectPlanInfo[item] = data[item];
        }
      });
    },
    dealParamsWithArray(obj) {
      let params = { ...obj }

      for (let item in params) {
        if (Array.isArray(params[item])){
          delete params[item]
        }
      }

      return params
    },
    getTableList() {
      let params = { ...this.selectForm }
      if (typeof(this.selectForm.stationId) == 'object') {
            params.stationId = this.selectForm.stationId.join(',')
            params.multiple_state = this.selectForm.multiple_state.join(',')
          }
      this.$api.applyManage.getBillManageList(params).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data.records.map((item) => {
            if (item.state === "已缴费") {
              item.tagType = "success";
            } else {
              item.tagType = "info";
            }
            return item;
          });
          this.pagination.total = res.data.total;
        }
      });
    },
    bachOper(res) {
      this.multipleSelectList = res.map((item) => {
        return item.id;
      });
    },
    getBillManageTotal() {
      let { page, size, orders, ...params } = this.selectForm;
      if (typeof(this.selectForm.stationId) == 'object') {
        params.stationId = this.selectForm.stationId.join(',')
        params.multiple_state = this.selectForm.multiple_state.join(',')
          }
      params = this.dealParamsWithArray(params)
      this.$api.applyManage.getBillManageTotal(params).then((res) => {
        if (res.code === 1) {
          this.totalPrice = res.data || 0;
        }
      });
    },
    showExportDialog() {
      this.dialogVisible = true;
    },
    exportData() {
      let { exportType, multipleSelectList } = this;
      if (!exportType) {
        this.$message.warning("请选择查询范围");
        return;
      }
      if (exportType === "2" && !multipleSelectList.length) {
        this.$message.warning("请选择导出数据");
        return;
      }
      let { page, size, orders, ...params } = this.selectForm;
      let newParams = {
        ...params,
        exportType,
        ids: multipleSelectList.toString(),
      };
      if (typeof(this.selectForm.stationId) == 'object') {
        newParams.stationId = this.selectForm.stationId.join(',')
        newParams.multiple_state = this.selectForm.multiple_state.join(',')
          }
      newParams = this.dealParamsWithArray(newParams)
      this.$api.applyManage.exportBillList(newParams).then((res) => {
        if (res.code === 1) {
          this.dialogVisible = false;
          window.open(res.data);
        }
      });
    },
    getResult() {
      this.selectForm.page = 1;
      this.getTableList();
      this.getBillManageTotal();
    },
    changeSize(num) {
      this.selectForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getTableList();
    },
    dealRefund(row) {
      this.refundForm.billId = row.id;

      //退费标记
      if (row.state == '已缴费') {
        this.studentInfo = row
        this.refundDialog = true

        if (row.payTypeId == "21") {
          this.HEMA = true;
        } else {
          this.HEMA = false;
        }

      // 撤销退费标记
      } else {
        this.$confirm('是否确认撤销退费标记？', '提示', {
          cancelButtonText: '否',
          confirmButtonText: '是',
          type: 'warning'
        }).then(() => {
          const { billId } = this.refundForm
          this.$api.applyManage.rePayBill({ billId }).then(({ code }) => {
            if (code == 1) {
              this.$message.success('操作成功')
              this.getResult()
            }
          })
        }).catch(error => {
          console.log(error)
        })
      }
    },


    /**
     * @param { 操作按钮权限配置, 是否可用 }
     */
    optionsFlag(row) {
      let btnFlag = false;

      if (this.selectPlanInfo.classPublish == 0) {
        if (row.state == "已缴费") {
          btnFlag = false;
        } else if (row.state == "退费") {
          btnFlag = false;
        } else {
          btnFlag = true;
        }
      } else {
        btnFlag = true;
      }

      return btnFlag;
    },


    /**
     * @param { 操作按钮内容配置，考场发布前可以操作 }
     * @param { 河马支付 => 操作按钮显示"退费" => 不需要退费时间 => 退费以后不显示撤销按钮 }
     * @param { 第三方自主缴费 => 操作按钮显示"退费标记" => 需要填退费时间 => 退费以后可以撤销退费 }
     */
    dealOptionsBtn(row) {
      const BTNLIST = [
        '<span>退费</span>',
        '<span>退费标记</span>',
        '<span>撤销退费</span>',
      ]

      let btnText;

      if (row.payTypeId == "21") {
        if (row.state == "已缴费") {
          btnText = BTNLIST[0];
        } else {
          btnText = null;
        }
      } else {
        if (row.state == "已缴费") {
          btnText = BTNLIST[1];
        } else if (row.state == '退费' && row.payTypeId == "-100") {
          btnText = BTNLIST[2];
        } else {
          btnText = null;
        }
      }

      return btnText;
    },



    refundFn() {
      this.$refs['refundForm'].validate(async (valid) => {
        if (valid) {
          this.$api.applyManage.refundBill(this.refundForm).then(({ code, data }) => {
            if (code == 1) {
              this.$message.success('操作成功')
              this.getResult()
              this.refundDialog = false
            }
          })
        }
      })
    }
  },
};
</script>

<style scoped lang="less">
.total-price {
  position: absolute;
  top: 28px;
  right: 24px;
  color: #45494d;
  .total-price-label {
    font-size: 13px;
  }
  .price {
    font-size: 20px;
    font-family: Arial-Black, Arial;
    font-weight: 900;
  }
}
.content {
  position: relative;
  margin-top: 16px;
  // padding: 24px;
  background: #fff;
  border-radius: 8px;
}
.dialogForm {
  /deep/ .el-form-item{
    display: flex;
    align-items: center;
  }
  /deep/ .el-form-item__label{
    padding-bottom: 0!important;
    text-align: right;
  }
}
</style>
